<template>
  <div class="offer-window">
    <div class="card">
      <div style="margin-bottom:6px;">
        Company:
        <company-select v-model="form.company_id" @change="changeCompany" :disabled="companyLocked"></company-select>&nbsp;
        <el-button @click="cache" v-if="!companyLocked">Lock</el-button>
        <el-button @click="clear" style="margin-left:2px;" v-if="companyLocked">Clear</el-button>
      </div>
      <hr/>
      <div flex>
        <div flex-box="5" style="margin-right:10px;">
          <div style="padding-left:4px;font-weight:bold;background-color:#ddd;height:26px;line-height:26px;margin-bottom:6px;">Quotation Note</div>
          <div>
            <el-input v-model="form.c_qty" placeholder="-qty-" style="width:90px;"></el-input>
            @
            <select v-model="form.c_currency" style="width:70px;" @change="form.currency = form.c_currency">
              <option label="USD" value="USD"></option>
              <option label="RMB" value="RMB"></option>
              <option label="HKD" value="HKD"></option>
            </select>
            &nbsp;
            <el-input v-model="form.c_price" placeholder="-price-" style="width:100px;"></el-input>
          </div>
          <div style="margin-top:6px;">
            lead time
            <select v-model="form.c_lead_time" style="width:80px;">
              <option v-for="item in leadTimes" :key="item" :value="item">{{ item }}</option>
            </select>
            remarks
            <el-input v-model="form.c_remark" placeholder="D/C,Packing" style="width:140px;"></el-input>
          </div>
        </div>
        <div flex-box="7">
          <div style="padding-left:4px;font-weight:bold;background-color:#ddd;height:26px;line-height:26px;margin-bottom:6px;">Offer
            <el-checkbox true-label="1" false-label="0" v-model="form.is_special" style="margin-left:10px;">special offer</el-checkbox>&nbsp;
            <i v-if="form.is_admin === '1'" class="iconfont icon-flag" style="color:red;cursor:pointer;" @click="form.is_admin = '0'"></i>
            <i v-else class="iconfont icon-flag" style="color:#999;cursor:pointer;" @click="form.is_admin = '1'"></i>
          </div>
          <div>
            <el-input v-model="form.qty" placeholder="-qty-" style="width:90px;"></el-input>
            @
            <select v-model="form.currency" style="width:70px;">
              <option value="USD">USD</option>
              <option value="RMB">RMB</option>
              <option value="HKD">HKD</option>
            </select>&nbsp;
            <el-input v-model="form.price" placeholder="market price" style="width:120px;"></el-input>
            D/C
            <select v-model="form.d_c" style="width:50px;">
              <option value="-">-</option>
              <option value="20+">20+</option>
              <option value="19+">19+</option>
              <option value="18+">18+</option>
              <option value="17+">17+</option>
              <option value="16+">16+</option>
              <option value="15+">15+</option>
              <option value="14+">14+</option>
              <option value="13+">13+</option>
              <option value="12+">12+</option>
              <option value="11+">11+</option>
              <option value="10+">10+</option>
              <option value="09+">09+</option>
              <option value="08+">08+</option>
              <option value="07+">07+</option>
              <option value="06+">06+</option>
              <option value="05+">05+</option>
              <option value="04+">04+</option>
              <option value="03+">03+</option>
              <option value="02+">02+</option>
              <option value="01+">01+</option>
            </select>&nbsp;
            C/O
            <el-input v-model="form.c_o" style="width:80px;"></el-input>
          </div>
          <div style="margin-top:6px;">
            valid period
            <select v-model="form.valid_period" style="width:50px;">
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
              <option value="7">7</option>
              <option value="8">8</option>
              <option value="9">9</option>
              <option value="10">10</option>
              <option value="15">15</option>
              <option value="20">20</option>
              <option value="30">30</option>
              <option value="45">45</option>
              <option value="60">60</option>
            </select>
            day(s)&nbsp;
            lead time
            <select v-model="form.lead_time" style="width:80px;">
              <option v-for="item in leadTimes" :key="item" :value="item">{{ item }}</option>
            </select>
            &nbsp;&nbsp;remarks
            <el-input v-model="form.remark" placeholder="D/C,Packing" style="width:120px;"></el-input>
          </div>
        </div>
      </div>
      <hr/>
      <div>
        for sales
        <select v-model="form.sales_id" style="width:100px;">
          <option v-for="item in salesList" :key="item.id" :label="item.realname" :value="item.id"></option>
        </select>
        <el-checkbox true-label="1" false-label="0" v-model="form.visibility" style="margin-left:10px;">visible</el-checkbox>
        <el-button @click="save" style="margin-left:20px;">Save</el-button>
        <el-button @click="saveAndExit">Save &amp; Exit</el-button>
        <el-button @click="reset">Reset</el-button>
        <el-button @click="$close()">Exit</el-button>
        <span style="margin-left:10px;">cysremarks</span>&nbsp;<el-input v-model="form.cysremark" placeholder="内部参考" style="width:120px;"></el-input>
      </div>
    </div>
    <div class="card">
      <div>
        Product No: {{ productId }} &nbsp;&nbsp;&nbsp;show
        <el-select v-model="pageSize" style="width:120px;" @change="fetchList">
          <el-option label="30 pcs" :value="30"></el-option>
          <el-option label="40 pcs" :value="40"></el-option>
          <el-option label="60 pcs" :value="60"></el-option>
          <el-option label="80 pcs" :value="80"></el-option>
          <el-option label="100 pcs" :value="100"></el-option>
          <el-option label="150 pcs" :value="150"></el-option>
          <el-option label="200 pcs" :value="200"></el-option>
          <el-option label="300 pcs" :value="300"></el-option>
        </el-select>
      </div>
      <div style="margin-top:10px;">
        <table class="cystron-table offer-table">
          <tr style="height:0;border:0">
            <th style="width:20px;"></th>
            <th style="width:90px;"></th>
            <th style="width:60px;"></th>
            <th style="width:40px;"></th>
            <th style="width:60px;"></th>
            <th style="width:50px;"></th>
            <th style="width:80px;"></th>
            <th style="width:40px;"></th>
            <th style="width:40px;"></th>
            <th style="width:60px;"></th>
            <th style="width:50px;"></th>
            <th style="width:35px;"></th>
            <th style="width:35px;"></th>
            <th style="width:60px;"></th>
            <th style="width:50px;"></th>
            <th style="width:75px;"></th>
            <th style="width:20px;"></th>
          </tr>
          <tr>
            <th colspan="8" style="border-right:1px solid #000;">
              quotation
            </th>
            <th colspan="9">
              offer
            </th>
          </tr>
          <tr>
            <th>Del</th>
            <th>input time</th>
            <th>company</th>
            <th>qty</th>
            <th>price</th>
            <th>LT</th>
            <th>remarks</th>
            <th style="border-right:1px solid #000;">sales</th>
            <th>qty</th>
            <th>price</th>
            <th>LT</th>
            <th>D/C</th>
            <th>C/O</th>
            <th>remarks</th>
            <th>special</th>
            <th>cysremarks</th>
            <th>&nbsp;</th>
          </tr>
          <tr v-for="(item, index) in list" :key="item.id" :class="trClass(item, index)">
            <td>
              <el-button type="danger" style="padding:0;" @click="del(item.id)">del</el-button>
            </td>
            <td>{{ item.oper_time | shortDateTime }}</td>
            <td :title="item.company_name">{{ item.company_name }}</td>
            <td>{{ item.c_qty }}</td>
            <td>{{ !item.c_price ? 'call' : item.c_currency + item.c_price }}</td>
            <td>{{ item.c_lead_time }}</td>
            <td :title="item.c_remark">{{ item.c_remark }}</td>
            <td style="border-right:1px solid #000;">
              <el-tooltip class="item" effect="dark" :content="item.sales_fullname + ',input by ' + item.oper_name" placement="bottom">
                <span>{{ item.sales_name }}</span>
              </el-tooltip>
            </td>
            <td>{{ item.qty === '' ? '-' : item.qty }}</td>
            <td>{{ !item.price ? 'call' : item.currency + item.price }}</td>
            <td>{{ item.lead_time }}</td>
            <td>{{ item.d_c }}</td>
            <td>{{ item.c_o }}</td>
            <td :title="item.remark">{{ item.remark }}</td>
            <td v-if="item.is_special === '1'">
              <el-button type="text" style="color:#000;font-weight:bold;padding:0;" @click="makeSpecial(item.id, '0')">special</el-button>
            </td>
            <td v-if="item.is_special === '0'">
              <el-button type="text" style="color:#999;padding:0;" @click="makeSpecial(item.id, '1')">special</el-button>
            </td>
            <td v-if="item.is_del === '0'" :title="item.cysremark">{{ item.cysremark }}</td>
            <td colspan="2" v-if="item.is_del === '1'">deleting by {{ item.del_name }}</td>
            <td v-if="item.is_admin === '1'">
              <i class="iconfont icon-flag" style="color:red;cursor:pointer;" @click="makeIsAdmin(item.id, '0')"></i>
            </td>
            <td v-if="item.is_admin === '0'">
              <i class="iconfont icon-flag" style="color:#999;cursor:pointer;" @click="makeIsAdmin(item.id, '1')"></i>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import CompanySelect from '@/components/CompanySelect'
export default {
  props: {
    productId: String
  },
  components: {
    CompanySelect
  },
  data () {
    return {
      sqlcode: 'product_offer_list',
      pageSize: 40,
      list: [],
      total: 0,
      loading: false,
      form: {
        company_id: localStorage.getItem('cystron-offer-company-id') ? parseInt(localStorage.getItem('cystron-offer-company-id')) : null,
        sales_id: localStorage.getItem('cystron-offer-sales-id') ? parseInt(localStorage.getItem('cystron-offer-sales-id')) : null,
        c_qty: '',
        c_currency: 'USD',
        c_price: '',
        c_lead_time: 'stock',
        c_remark: '',
        qty: '',
        currency: 'USD',
        price: '',
        valid_period: '4',
        lead_time: 'stock',
        remark: '',
        cysremark: '',
        visibility: '1',
        is_special: '0',
        is_admin: '0',
        product_id: this.productId,
        d_c: '-',
        c_o: ''
      },
      companyLocked: !!localStorage.getItem('cystron-offer-company-id')
    }
  },
  computed: {
    leadTimes () {
      return this.$store.state.select.leadtimes
    },
    salesList () {
      return this.$store.state.select.sales
    }
  },
  mounted () {
    this.$store.dispatch('fetchSelect', 'sales')
    this.fetchList()
  },
  methods: {
    fetchList () {
      this.loading = true
      this.$http.get('/dbapi/' + this.sqlcode, {
        params: {
          product_id: this.productId,
          start: 0,
          limit: this.pageSize
        }
      }).then(data => {
        this.loading = false
        this.list = data.list
        this.total = data.total
        if (this.list.length > 0) {
          this.form.remark = this.list[0].remark
          this.form.d_c = this.list[0].d_c
          this.form.c_o = this.list[0].c_o
        }
      }).catch(() => this.loading = false)
    },
    refresh () {
      this.fetchList()
    },
    cache () {
      if (!this.form.company_id) {
        return
      }
      localStorage.setItem('cystron-offer-company-id', this.form.company_id)
      localStorage.setItem('cystron-offer-sales-id', this.form.sales_id)
      this.companyLocked = true
    },
    clear () {
      this.form.company_id = null
      localStorage.removeItem('cystron-offer-company-id')
      localStorage.removeItem('cystron-offer-sales-id')
      this.companyLocked = false
    },
    save () {
      if (!this.form.company_id) {
        this.$message({
          type: 'error',
          message: 'Please select a company'
        })
        return
      }
      this.$http.post('/dbapi/offer_insert', this.form).then(data => {
        this.$message({
          type: 'success',
          message: 'Saved.'
        })
        this.refresh()
      })
    },
    saveAndExit () {
      if (!this.form.company_id) {
        this.$message({
          type: 'error',
          message: 'Please select a company'
        })
        return
      }
      this.$http.post('/dbapi/offer_insert', this.form).then(data => {
        this.$message({
          type: 'success',
          message: 'Saved.'
        })
        this.$close()
      })
    },
    reset () {
      this.form = {
        company_id: null,
        sales_id: null,
        c_qty: '',
        c_currency: 'USD',
        c_price: '',
        c_lead_time: 'Stock',
        c_remark: '',
        qty: '',
        currency: 'USD',
        price: '',
        valid_period: '4',
        lead_time: '7 days',
        remark: '',
        cysremark: '',
        visibility: '1',
        is_special: '0',
        is_admin: '0',
        product_id: this.productId,
        d_c: '-',
        c_o: ''
      }
    },
    makeSpecial (id, is_special) {
      this.$http.post('/dbapi/offer_special', {
        id,
        is_special,
        product_id: this.productId
      }).then(data => {
        this.refresh()
      })
    },
    makeIsAdmin (id, is_admin) {
      this.$http.post('/dbapi/offer_is_admin', {
        id,
        is_admin
      }).then(data => {
        this.refresh()
      })
    },
    del (id) {
      this.$confirm('Delete?', 'Confirm', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/offer_del', { id: id }).then(data => {
          this.$message({
            type: 'success',
            message: 'Deleted.'
          })
          this.refresh()
        })
      })
    },
    changeCompany (val) {
      this.form.sales_id = val.sales_id
    },
    trClass (item, index) {
      if (item.is_del === '1') {
        return 'row-red'
      }
      if (item.is_special === '1') {
        return 'row-bg-yellow'
      }
      if (index % 2 === 1) {
        return 'row-bg-gray'
      }
      return ''
    }
  }
}
</script>

<style lang="scss">
.offer-window {
  .del-radio {
    .el-radio__label {
      display: none;
    }
  }
  .offer-table {
    table-layout: fixed;
    td {
      word-break: keep-all;/* 不换行 */
      white-space: nowrap;/* 不换行 */
      overflow: hidden;/* 内容超出宽度时隐藏超出部分的内容 */
      text-overflow: ellipsis;/* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用。*/
    }
  }
}
</style>
